module.exports = __webpack_public_path__ + "static/media/ProximaNova-Light.0188899c.ttf";